import { enforceNumber } from '../typing';

export const navigateCalendar = ({
  command,
  calendar,
  goToNextMonth,
  goToPrevMonth,
  focusDay,
  getCalendar,
}: {
  command: 'ArrowDown' | 'ArrowUp' | 'ArrowLeft' | 'ArrowRight';
  calendar: string[][];
  goToNextMonth(): void;
  goToPrevMonth(): void;
  focusDay(row: number, col: number, currentActive: Element | null): void;
  getCalendar(): string[][];
}) => {
  const maxCols = 6;
  const currentActive = document.activeElement;
  let row = enforceNumber(currentActive?.getAttribute('data-row'));
  let col = enforceNumber(currentActive?.getAttribute('data-col'));
  let maxRows = calendar.length - 1;

  const indice = {
    ArrowDown: () => {
      row += row < maxRows && calendar[row + 1][col] === '' ? 2 : 1;

      if (row > maxRows) {
        goToNextMonth();

        if (JSON.stringify(calendar) !== JSON.stringify(getCalendar())) {
          maxRows = getCalendar().length - 1;
          /* istanbul ignore next */
          // condição : 0
          row = getCalendar()[0][col] === '' ? 1 : 0;
        }
      }
    },
    ArrowUp: () => {
      row -= row > 0 && calendar[row - 1][col] === '' ? 2 : 1;

      if (row < 0) {
        goToPrevMonth();

        if (JSON.stringify(calendar) !== JSON.stringify(getCalendar())) {
          maxRows = getCalendar().length - 1;
          row = getCalendar()[maxRows][col] === '' ? maxRows - 1 : maxRows;
        }
      }
    },
    ArrowRight: () => {
      const lastDay = calendar[maxRows].filter((d) => d).length - 1;

      if (row !== maxRows && col === maxCols) {
        row += 1;
        col = 0;
      } else {
        col += 1;
      }

      if (row === maxRows && col > lastDay) {
        goToNextMonth();

        if (JSON.stringify(calendar) !== JSON.stringify(getCalendar())) {
          col = getCalendar()[0].findIndex((start) => start === '1');
          /* istanbul ignore next */
          // condição ?1
          row = getCalendar()[0][col] === '' ? 1 : 0;
        }
      }
    },
    ArrowLeft: () => {
      if (row !== 0 && col === 0) {
        row -= 1;
        col = maxCols;
      } else {
        col -= 1;
      }

      const firstDay = calendar[0].findIndex((start) => start === '1');

      if (col < firstDay && row === 0) {
        goToPrevMonth();

        if (JSON.stringify(calendar) !== JSON.stringify(getCalendar())) {
          maxRows = getCalendar().length - 1;
          col = getCalendar()[maxRows].filter((d) => d).length - 1;
          /* istanbul ignore next */
          // condição maxRows - 1, não foi possível simular
          row = getCalendar()[maxRows][col] === '' ? maxRows - 1 : maxRows;
        }
      }
    },
  }[command];

  /* istanbul ignore next */
  // branch de ausencia de indice, não é possível testar
  indice?.();

  focusDay(row, col, currentActive);
};
